"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var isBefore_1 = tslib_1.__importDefault(require("date-fns/isBefore"));
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var setupApis_1 = require("../../../api/setupApis");
var DayEventsBlock_1 = tslib_1.__importDefault(require("./DayEventsBlock"));
var utilities_1 = require("./utilities");
var startOfDay_1 = tslib_1.__importDefault(require("date-fns/startOfDay"));
setupApis_1.setupTvProgramApi();
var EventsListWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-family: 'Open Sans', 'open-sans', sans-serif;\n  ", ";\n"], ["\n  font-family: 'Open Sans', 'open-sans', sans-serif;\n  ",
    ";\n"])), function (_a) {
    var compact = _a.compact;
    return compact && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      padding: ", ";\n      border: 1px solid #ddd;\n      border-radius: ", ";\n    "], ["\n      padding: ", ";\n      border: 1px solid #ddd;\n      border-radius: ", ";\n    "])), polished_1.rem(24), polished_1.rem(8));
});
var WidgetTvProgram = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.widgetData, widgetData = _f === void 0 ? {} : _f;
    var _g = react_1["default"].useState({
        events: (_c = (_b = widgetData.data) === null || _b === void 0 ? void 0 : _b.events) !== null && _c !== void 0 ? _c : [],
        nextOffset: (_d = widgetData.data) === null || _d === void 0 ? void 0 : _d.nextOffset
    }), tvProgramList = _g[0], setTvProgramList = _g[1];
    var _h = react_1["default"].useState(false), isLoading = _h[0], setIsLoading = _h[1];
    var handleLoadMore = function (override) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var dateFrom, dateTo, res_1, e_1;
        var _a, _b, _c, _d, _e;
        return tslib_1.__generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    setIsLoading(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    dateFrom = widgetData.dateRangeOptions === 'recent' && !widgetData.dateFrom
                        ? new Date()
                        : widgetData.dateFrom
                            ? new Date(widgetData.dateFrom)
                            : undefined;
                    dateTo = widgetData.dateTo
                        ? new Date(widgetData.dateTo)
                        : undefined;
                    return [4 /*yield*/, utilities_1.getEvents({
                            offset: override.offset,
                            dateFrom: dateFrom === null || dateFrom === void 0 ? void 0 : dateFrom.toJSON(),
                            dateTo: dateTo === null || dateTo === void 0 ? void 0 : dateTo.toJSON(),
                            limit: (_b = (_a = override === null || override === void 0 ? void 0 : override.limit) !== null && _a !== void 0 ? _a : widgetData.limit) !== null && _b !== void 0 ? _b : 5,
                            sportId: (_c = widgetData.sport) === null || _c === void 0 ? void 0 : _c._id,
                            providerId: (_d = widgetData.provider) === null || _d === void 0 ? void 0 : _d._id,
                            competitionId: (_e = widgetData.competition) === null || _e === void 0 ? void 0 : _e._id,
                            priority: widgetData.priority
                        })];
                case 2:
                    res_1 = _f.sent();
                    setTvProgramList(function (prev) {
                        var prevEvents = tslib_1.__spreadArrays(prev.events);
                        return {
                            events: tslib_1.__spreadArrays(prevEvents, res_1.events),
                            nextOffset: res_1.nextOffset
                        };
                    });
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _f.sent();
                    console.error(e_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // kedze API defaultne vracia eventy, ktore zacali pred polnocou, ale pokracuju
    // v datum od ktoreho filtrujeme, musime na zaklade poziadavky pre TV widgety tieto eventy
    // odstranovat. Na stranke TV programu je poziadavka opacna - zobrazovat aj eventy, ktore zacali
    // pred polnocou a pokracuju v dany (dnesny) den.
    var events = (tvProgramList.events || []).reduce(function (acc, event) {
        // najblizsie
        var eventDateFrom = new Date(event.dateFrom);
        if (widgetData.dateRangeOptions === 'recent') {
            acc.push(event);
        }
        else {
            if (widgetData.dateFrom) {
                if (!isBefore_1["default"](eventDateFrom, startOfDay_1["default"](new Date(widgetData.dateFrom)))) {
                    acc.push(event);
                }
            }
            else {
                acc.push(event);
            }
        }
        return acc;
    }, []);
    return (react_1["default"].createElement(EventsListWrapper, { compact: widgetData.view === 'compact', className: "content-widget-tvProgram" },
        react_1["default"].createElement(DayEventsBlock_1["default"], tslib_1.__assign({ className: "day-events-block", date: widgetData.dateFrom ? new Date(widgetData.dateFrom) : new Date(), events: events, isLoading: isLoading, title: (_e = widgetData.customTitle) !== null && _e !== void 0 ? _e : 'generated', subtitle: widgetData.subtitleOption
                ? widgetData[widgetData.subtitleOption]
                : undefined, compact: widgetData.view === 'compact', lastRowUrl: widgetData.lastRowUrl }, !!widgetData.banner ? { banner: widgetData.banner } : {}, { handleLoadMore: tvProgramList.nextOffset
                ? function () {
                    handleLoadMore({
                        offset: tvProgramList.nextOffset
                    });
                }
                : undefined }))));
};
exports["default"] = react_1["default"].memo(WidgetTvProgram);
var templateObject_1, templateObject_2;
